import React, { useState, useEffect, useRef } from 'react';

import Header from '../../components/user/header/Header.jsx';

import MainVisual from '../../components/user/main/MainVisual.jsx';
import Section1 from '../../components/user/main/Section1.jsx';
import Section2 from '../../components/user/main/Section2.jsx';
import Section3 from '../../components/user/main/Section3.jsx';
import Section4 from '../../components/user/main/Section4.jsx';
import Section5 from '../../components/user/main/Section5.jsx';


import Footer from '../../components/user/footer/Footer.jsx';

import '../../styles/user/common.css';
import '../../styles/user/default.css';
import '../../styles/user/fixed.css';
import '../../styles/user/font.css';
import '../../styles/user/footer.css';
import '../../styles/user/header.css';
import '../../styles/user/main.css';
import '../../styles/user/slick-theme.css';
import '../../styles/user/slick.css';
import '../../styles/user/sub.css';

export default function Main() {
  return (
    <>
      <Header />
      
      <MainVisual />
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />

     

      <Footer />
    </>
  );
}
